import {
  balanceSheetColumnDefinition,
  enabledFlagColumnDefinition,
  goldIdColumnDefintion,
  plAccountColumnDefinition,
  reclassBsAccountColumnDefinition,
  reclassPlAccountColumnDefinition,
  taxDescriptionColumnDefinition,
} from '../columnDefinitions';

export default [
  { ...taxDescriptionColumnDefinition, headerName: 'Tax Accounting' },
  enabledFlagColumnDefinition,
  plAccountColumnDefinition,
  balanceSheetColumnDefinition,
  reclassPlAccountColumnDefinition,
  reclassBsAccountColumnDefinition,
  goldIdColumnDefintion,
];
